import parse from 'html-react-parser'
import { intersection } from 'lodash'
import parsehortcodes from './shortcode'
import Loader from './loader'

const blockcomponents = {
  'wp-block-playmotivcloud-controlledcontent': {
    path: 'playmotiv-cloud-core-v4/content/controlledcontent'
  },
  'wp-block-playmotivcloud-slide': {
    path: 'playmotiv-cloud-core-v4/content/slide'
  },
  'playmotiv-shortcode': {
    path: 'playmotiv-cloud-core-v4/content/shortcode'
  },
  'playmotiv-action-class': {
    path: 'playmotiv-cloud-core-v4/ui/button/actionclass'
  },
  'wp-block-playmotivcloud-amazonredim': {
    path: 'playmotiv-cloud-core-v4/redim/amazon'
  },
  'wp-block-playmotivcloud-vimeoplayer': {
    path: 'playmotiv-cloud-core-v4/media/vimeoplayer'
  },
  'wp-block-playmotivcloud-vimeoplayerevaluable': {
    path: 'playmotiv-cloud-core-v4/media/vimeoplayerevaluable'
  },
  'wp-block-playmotivcloud-ranking': {
    path: 'playmotiv-cloud-core-v4/content/ranking'
  },
  'wp-block-playmotivcloud-forms': {
    path: 'playmotiv-cloud-core-v4/forms/base'
  }
}

let actualstore

const parser = {}

const replace = (domNode, store, rootReplace) => {

  // detect by attribute data-component

  if(domNode.attribs && domNode.attribs['data-component']) {

    const componentpath = domNode.attribs['data-component']
    
    return <Loader 
      component={ componentpath }
      replace={ rootReplace ? rootReplace : replace }
      store={ store ? store :  actualstore }
      { ...domNode } 
    />
  }

  // detect by classname & blockcomponents table

  const blockcomponentkeys = Object.keys(blockcomponents)
  const classes = domNode.attribs?.class?.split(' ');
  const replacecomponent = intersection(blockcomponentkeys, classes)
  
  if(replacecomponent.length) {

    const blockcomponentkey = replacecomponent[0]

    return <Loader 
      component={ blockcomponents[blockcomponentkey].path }
      replace={ rootReplace ? rootReplace : replace }
      store={ store ? store :  actualstore }
      { ...domNode } 
    />
  }

  return domNode
}

const parseHtml = (html, store) => {

  actualstore = store

  const parsed = parse(
    parsehortcodes(html), 
    {
      replace: replace
    }
  )

  return parsed
}

parser.replace = replace
parser.parseHtml = parseHtml

if(!window.playmotiv) { window.playmotiv = {} }
window.playmotiv.parser = parser